import _objectSpread from "@babel/runtime/helpers/objectSpread2";
export default function convertAvatar(component) {
  var properties = component.properties;
  var props = properties;
  return {
    brick: "eo-avatar",
    properties: _objectSpread(_objectSpread({}, props), {}, {
      themeVariant: "elevo"
    })
  };
}
//# sourceMappingURL=convertAvatar.js.map